import { Component } from '@angular/core';

@Component({
   selector: 'ndt-homer-logo',
   templateUrl: './homer-logo.component.html',
   styleUrls: ['../logo-icon.scss'],
   standalone: false,
})
export class HomerLogoComponent {}
